import { render } from "./AtendimentoPergunta.vue?vue&type=template&id=9b712ec2"
import script from "./AtendimentoPergunta.vue?vue&type=script&lang=js"
export * from "./AtendimentoPergunta.vue?vue&type=script&lang=js"

import exportComponent from "/builds/ssp/csmpmview/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__